<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:22
 * @LastEditors: yd
 * @LastEditTime: 2020-08-12 13:52:53
-->
<template>
  <div>
    <Levelcomponents></Levelcomponents>
  </div>
</template>

<script> 
import Levelcomponents from './modules/Levelcomponents'
export default {
  components: {
    Levelcomponents
  },
  props: {},
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
</style>
